import {AxiosPromise} from "axios"
import RequestHelper, {ActionAnswer} from "../utils/RequestsHelper"

export interface AttributeDictionary {
    attribute_id: string,
    category_id: string,
    id: string,
    value: string,
    value_id: string
}

export interface DownloadStatus {
    id: number
    status: "processing" | "complete"
    text: string
}

export default class DictionaryApi {
    public static getAttributeDictionary(data: { query: string, category_id?: number, attribute_id?: number }): AxiosPromise<ActionAnswer<AttributeDictionary[]>> {
        return RequestHelper.send("get", "dictionary&action=dictionary", data)
    }

    public static runDownload(data: { category_id: number, attribute_id: number }): AxiosPromise<ActionAnswer<DownloadStatus>> {
        return RequestHelper.send("get", "dictionary&action=runDownload", data)
    }

    public static downloadStatus(data: { task_id: number }): AxiosPromise<ActionAnswer<DownloadStatus>> {
        return RequestHelper.send("get", "dictionary&action=downloadStatus", data)
    }
    public static findStatus(data: { category_id: number, attribute_id: number }): AxiosPromise<ActionAnswer<DownloadStatus>> {
        return RequestHelper.send("get", "dictionary&action=getStatus", data)
    }

    public static runDownloadDictionary(data: { category_id: string, attribute_id: string }): AxiosPromise<ActionAnswer> {
        return RequestHelper.send("get", "backend&action=dictionariesDownload", data)
    }
}